<template>
  <div
    v-if="CNF('copyright.visiable', true)">
    {{CNF('copyright.text', '')}}
  </div>
</template>

<script>
export default {
  name: 'ZjFooter'
}
</script>
